import styles from './supply-payment-required-modal.module.css'

export const generateContainerClasses = (isOpen: boolean) => {
  return `${styles.container} ${isOpen ? styles.open : ''} `
}
